import { Button, ButtonBase, Divider } from "@mui/material";
import dayjs from "dayjs";
import { useTranslations } from "use-intl";

import { Image } from "@/components/Image/Image";
import {
  DetailsList,
  DetailsListItem,
} from "@/features/trips/components/DetailsList";
import type { FindUserPackageBookingsPackageBooking } from "@/types/codegen";

type Props = {
  booking: FindUserPackageBookingsPackageBooking;
  onClick: () => void;
};

export function TripBookingCard({ booking, onClick }: Props) {
  const t = useTranslations();

  const startDateFormatted = dayjs(booking.startDate).format("D MMMM, YYYY");
  const endDateFormatted = dayjs(booking.startDate)
    .add(booking.package.durationInDays, "day")
    .format("D MMMM, YYYY");

  return (
    <ButtonBase
      onClick={onClick}
      sx={{
        padding: "calc(var(--spacing))",
        backgroundColor: "var(--color-white)",
        borderRadius: "var(--radius-2xl)",
        display: "block",
        width: "100%",
        textAlign: "initial",
      }}
    >
      <Image
        src={booking.package.imageUrls[0]}
        alt={booking.package.name}
        className="aspect-7/2 w-full rounded-t-xl object-cover"
      />

      <div className="p-3">
        <div className="mb-1 text-xl font-medium text-text-title">
          {booking.package.name}
        </div>
        <div className="text-sm text-text-tertiary">
          {booking.package.subtitle}
        </div>

        <Divider
          sx={{
            borderColor: "var(--color-stroke-neutral-soft)",
            my: "calc(var(--spacing)*3)",
          }}
        />

        <DetailsList className="mb-4">
          <DetailsListItem
            title={t("trips.travelStartDate")}
            value={startDateFormatted}
          />

          <DetailsListItem
            title={t("trips.travelEndDate")}
            value={endDateFormatted}
          />
        </DetailsList>

        <Button
          component="span"
          role={undefined}
          variant="outlined"
          fullWidth
          size="small"
        >
          {t("trips.tripDetails.title")}
        </Button>
      </div>
    </ButtonBase>
  );
}
